export enum QuickIntakeFormState {
  FORM = 'form',
  ERROR = 'error',
  PROCESSING = 'processing',
  SUBMITTED = 'submitted'
}
